import React from "react";
import { Outlet } from "react-router-dom";
import Content from "../../Components/Core/Content";

const Setting = () => {
  return (
    <div className="container-fluid p-0 mb-4">
      <Content>
        {" "}
        <Outlet />
      </Content>
    </div>
  );
};

export default Setting;
